export function invitationResult(data, update = false) {
  if (data?.ok !== true) throw new Error(data?.message || 'The client invitation could not be saved.');
  const pending = !update && data.association_pending === true;
  const emailDelivery = update ? undefined : pending ? data.invitation?.email_delivery : data.email_delivery;
  const emailMessage = emailDelivery === 'failed'
    ? ' Email delivery was not confirmed. Send the invitation again to retry.'
    : emailDelivery === 'submitted'
      ? ' The invitation email was submitted for delivery.'
      : '';
  return {
    pending,
    tone: emailDelivery === 'failed' ? 'warning' : 'success',
    message: pending
      ? `Invitation pending in MyCaseCare.${emailMessage} Your firm cannot access this client’s existing records until the client accepts in MyCaseCare.`
      : data.message || (update
        ? 'Client updated.'
        : emailDelivery === 'failed'
          ? 'Client created. Email delivery was not confirmed. Contact the client to arrange access to MyCaseCare.'
          : `Client created.${emailMessage}`),
    event: update ? 'client_updated' : pending ? 'association_invitation_created' : 'new_client_created',
  };
}
